import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

export const getMyLotsBuyerAPI = async (params, query = {}) => {
  return await axios({
    method: "get",
    url: `${config.api.base_url}events/${params.eventId}/buyer-items`,
    data: { ...query },
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default getMyLotsBuyerAPI;
